import { debounce } from 'lodash';

import { useEuiFiltersDispatch } from '../EuiFiltersContext';
import { setDataGridStateAndCacheProcessor } from '../processors';

import useFilterSyncCache from './useFilterSyncCache';

const debounceOnStateChange = debounce(cb => cb(), 800);

export default function useDataGridOnStateChange() {
  const dispatch = useEuiFiltersDispatch();

  useFilterSyncCache({ uniqKey: 'dataGridState' });

  return onStateChange;

  function onStateChange(a, b, c) {
    debounceOnStateChange(function() {
      if (!c.api.exportState) {
        return;
      }

      dispatch({
        type: 'PERFORM',
        processor: setDataGridStateAndCacheProcessor,
        payload: c.api.exportState()
      });
    });
  }
}
